/**
 * homepage-chart-viewing
 *
 * @author    Alexis Vedia <alexis.vedia@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

export default sb => {
    let chart;
    let title;

    /**
     * @param {Object} data
     * @param {String} data.week
     * @param {Array} data.viewing_data
     */
    const renderChart = function renderChart(data) {
        const options = {
            title: {
                text: ""
            },
            chart: {
                type: 'bar',
                marginRight: 30,
                backgroundColor: '#ffffff'
            },
            colors: ['#d5a00c'],
            xAxis: {
                title: null,
                categories: Object.keys(data.viewing_data),
                tickColor: "#ffffff",
                lineWidth: 0
            },
            yAxis: {
                min: 0,
                title: "Viewers",
                gridZIndex: 4,
                gridLineColor: "#ffffff",
                labels: {"enabled": false},
                tickInterval: 1000
            },
            plotOptions: {
                series: {
                    borderColor: "#d5a00c",
                    dataLabels: {
                        enabled: true,
                        color: "#000000",
                        crop: false,
                        overflow: "none"
                    }
                }
            },
            tooltip: {enabled: false},
            series: [{
                name: 'Consolidated audience (000s)',
                data: Object.keys(data.viewing_data).map(k => data.viewing_data[k])
            }],
            credits: {enabled: false}
        };
        sb.append(title, '<h1>Most popular programmes</h1><h2>w/e ' + data.week + '</h2>');
        sb.chart(chart, options);
    };

    return {
        init() {
            chart = sb.find(".chart_section");
            title = sb.find(".chart_title");
            sb.postApi("/get-homepage-chart").then(renderChart);
        },
        destroy() {
            chart = null;
            title = null;
        }
    }
};

